/** Canonical Virtual IP IA routes (Project / Asset). */

export function virtualIpProjectsPath(workspaceId: string): string {
  return `/workspace/${workspaceId}/virtual-ip/projects`
}

export function virtualIpAssetsPath(workspaceId: string): string {
  return `/workspace/${workspaceId}/virtual-ip/assets`
}

export function virtualIpAssetDetailPath(workspaceId: string, assetId: string): string {
  return `/workspace/${workspaceId}/virtual-ip/assets/${assetId}`
}

export function virtualIpProjectBase(workspaceId: string, projectId: string): string {
  return `/workspace/${workspaceId}/virtual-ip/projects/${projectId}`
}

export function virtualIpProjectStepPath(
  workspaceId: string,
  projectId: string,
  stepRoute: string,
): string {
  return `${virtualIpProjectBase(workspaceId, projectId)}/${stepRoute}`
}

/** Legacy bookmark: `/virtual-ip-positioning/...` */
export function virtualIpLegacyPositioningBase(workspaceId: string): string {
  return `/workspace/${workspaceId}/virtual-ip-positioning`
}
